/**
 * SIDC MMS Core
 * Our Endpoints are powered by .Net Core, Onion Architecture, CQRS with MediatR Library,Entity Framework Core - Code First,Repository Pattern - Generic, Swagger UI, API Versioning,Fluent Validation and Automapper.
 *
 * OpenAPI spec version: v1
 * Contact: sidcmisdepartment@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpdateYoungCooperatorCommand { 
    youngCooperatorId?: number;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffixName?: string;
    mobileNumber?: string;
    emailAddress?: string;
    birthdate?: Date;
    age?: number;
    street?: string;
    barangay?: string;
    city?: string;
    province?: string;
    zipCode?: string;
    religion?: string;
    schoolName?: string;
    schoolAddress?: string;
    regionId?: number;
    membershipType?: string;
    profilePicture?: string;
    branchId?: number;
    genderId?: number;
    generatedBy?: string;
}